<template>
    <div class="menu-page">

        <v-card class="nd-border mt-4" flat>
            <v-card-title>Login Meta - API Oficial Whatsapp</v-card-title>
            <v-card-text>
                <button @click="launchWhatsAppSignup" style="background-color: #1877f2; border: 0; border-radius: 4px; color: #fff; cursor: pointer; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; height: 40px; padding: 0 24px;">Login com Facebook</button>
            </v-card-text>
        </v-card>

    </div>
</template>

<script>
export default {
    name: "MetaLoginView",

    data() {
        return {};
    },
    mounted() {
        this.$store.commit('setBreadcrumbs', [
            { label: 'Login Meta - API Oficial Whatsapp' },
        ])
    },
    methods: {
        launchWhatsAppSignup() {
            const fbLoginCallback = (response) => {
                console.log('fbLoginCallback')
                console.log(response)

                if (response.authResponse) {
                    const code = response.authResponse.code;

                }
            }

            FB.login(fbLoginCallback, { // eslint-disable-line
                config_id: '1176745574137625', // configuration ID goes here
                response_type: 'code', // must be set to 'code' for System User access token
                override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
                extras: {
                    setup: { "business": { "id": null, "name": null, "email": null, "phone": { "code": null, "number": null }, "website": null, "address": { "streetAddress1": null, "streetAddress2": null, "city": null, "state": null, "zipPostal": null, "country": null }, "timezone": null }, "phone": { "displayName": null, "category": null, "description": null }, "preVerifiedPhone": { "ids": null }, "solutionID": null, "whatsAppBusinessAccount": { "ids": null } },
                    featureType: 'only_waba_sharing',
                    sessionInfoVersion: '2',
                }
            });
        }
    },
};
</script>